import React from 'react';
import { Link } from 'react-router-dom';

// Prev/next buttons between periods of the SAME kind (weekly vs monthly) and explicitness
// (normal summaries link to the next normal one, explicit summaries link to the next explicit
// one) - this is already guaranteed server-side by the API's navigation query
// (MediaUpdate.update_type == update.update_type), no filtering needed here.
const PeriodNav = ({ prev, next }) => {
  if (!prev && !next) {
    return null;
  }

  return (
    <div className="period-summary-nav">
      {prev ? (
        <Link
          to={`/period-summary/${prev.id}`}
          className="btn period-summary-nav-btn period-summary-nav-prev"
          title={prev.title}
        >
          <img src="/static/icons/arrow-left-solid.svg" alt="" className="icon" />
          <span>{prev.title}</span>
        </Link>
      ) : (
        <span className="period-summary-nav-spacer" />
      )}
      {next ? (
        <Link
          to={`/period-summary/${next.id}`}
          className="btn period-summary-nav-btn period-summary-nav-next"
          title={next.title}
        >
          <span>{next.title}</span>
          <img src="/static/icons/arrow-right-solid.svg" alt="" className="icon" />
        </Link>
      ) : (
        <span className="period-summary-nav-spacer" />
      )}
    </div>
  );
};

export default PeriodNav;
